import { render, staticRenderFns } from "./VideoAdd.vue?vue&type=template&id=261e3aff&scoped=true&"
import script from "./VideoAdd.vue?vue&type=script&lang=js&"
export * from "./VideoAdd.vue?vue&type=script&lang=js&"
import style0 from "./VideoAdd.vue?vue&type=style&index=0&id=261e3aff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261e3aff",
  null
  
)

export default component.exports